export const getResponseData = (response) => response?.data;

export const unwrapApiData = async (requestPromise) => {
  const response = await requestPromise;
  return getResponseData(response);
};
